import Modal from 'src/components/atoms/modal/modal';
import { User } from 'src/models/user.model';
import { RootState, useAppDispatch, useAppSelector } from 'src/reducers';
import styles from '../commissions.module.scss';
import Checkbox from 'src/components/atoms/checkbox/checkbox';
import { useCallback, useEffect, useState } from 'react';
import { updateCommissionUsers } from 'src/reducers/updates-commission-relations.reducer';
import { getUsers } from 'src/reducers/user.reducer';
import Pagination from 'src/components/atoms/pagination/pagination';
import { userDefaultParams } from 'src/utils/pagination-utils';
import Spinner from '../../../atoms/spinner/spinner';

type Props = {
  commissionId: number;
  associatedUsers: User[];
};

export const UpdateUsersRelations = (props: Props) => {
  const { commissionId, associatedUsers } = props;

  const dispatch = useAppDispatch();

  const [checkedUserIds, setCheckedUserIds] = useState<number[]>([]);
  const [pagination, setPagination] = useState(userDefaultParams);

  const userReducer = useAppSelector((state: RootState) => state.user);

  useEffect(() => {
    dispatch(getUsers({ pagination }));
  }, [dispatch, pagination]);

  useEffect(() => {
    if (associatedUsers && associatedUsers.length > 0) {
      const initialCheckedUserIds = associatedUsers.map(capability => capability.id);
      setCheckedUserIds(initialCheckedUserIds);
    }
  }, [associatedUsers]);

  const handleCheckUser = useCallback(
    (userId: number) => {
      if (checkedUserIds.includes(userId)) {
        const updatedCheckedUserIds = checkedUserIds.filter(id => id !== userId);
        setCheckedUserIds(updatedCheckedUserIds);
      } else {
        const updatedCheckedUserIds = [...checkedUserIds, userId];
        setCheckedUserIds(updatedCheckedUserIds);
      }

      dispatch(
        updateCommissionUsers({
          userId,
          commissionId,
        })
      );
    },
    [checkedUserIds, commissionId, dispatch, pagination]
  );

  const handlePageChange = (page: number) => {
    setPagination(prev => ({
      ...prev,
      currentPage: page + 1,
    }));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <div className={styles.modalForUpdates}>
          {userReducer.loading && <Spinner />}
          {!userReducer.loading && userReducer.failure && <div>Errore nel caricamento degli utenti</div>}
          {!userReducer.loading && userReducer.success && userReducer.users.length === 0 && <div>Nessun utente trovato.</div>}
          {!userReducer.loading &&
            userReducer.success &&
            userReducer.users.length > 0 &&
            userReducer.users.map(user => (
              <div className={styles.roleForCommissionCard} key={user.id}>
                <Checkbox checked={checkedUserIds.includes(user.id)} onCheck={() => handleCheckUser(user.id)} />
                <div>{user.email}</div>
              </div>
            ))}
        </div>
        <Pagination
          activePage={pagination.currentPage - 1}
          itemsPerPage={pagination.postPerPage}
          totalItems={userReducer.totalItems}
          paginate={handlePageChange}
        />
      </Modal.Body>
    </>
  );
};
